import { useEffect, useState } from "react";

const navItems = [
  { id: "overview", label: "主题概览" },
  { id: "categories", label: "作品类型" },
  { id: "catalog", label: "作品目录" },
  { id: "collections", label: "合集组织" },
  { id: "series", label: "系列说明" },
  { id: "recommend", label: "推荐方向" },
  { id: "faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 w-full transition-all duration-300 ${
        solid
          ? "border-b border-background-200/70 bg-background-50/95 backdrop-blur-md"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 w-full items-center justify-between gap-4 px-4 md:px-8">
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-film-line text-lg"></i>
          </span>
          <span
            className={`font-heading text-base font-semibold tracking-tight md:text-lg ${
              solid ? "text-foreground-950" : "text-background-50"
            }`}
          >
            三上悠亚电影
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={`whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                solid
                  ? "text-foreground-700 hover:bg-primary-100/70 hover:text-primary-700"
                  : "text-background-100/90 hover:bg-white/10 hover:text-background-50"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#catalog"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            查看条目清单
          </a>
          <button
            type="button"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className={`flex h-10 w-10 items-center justify-center rounded-md transition-colors lg:hidden ${
              solid ? "text-foreground-900 hover:bg-background-200/70" : "text-background-50 hover:bg-white/10"
            }`}
          >
            <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {open ? (
        <div className="border-t border-background-200/70 bg-background-50 lg:hidden">
          <nav className="mx-auto flex max-w-content flex-col px-4 py-3">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setOpen(false)}
                className="flex items-center justify-between rounded-md px-3 py-3 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-100/70 hover:text-primary-700"
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-lg text-foreground-400"></i>
              </a>
            ))}
            <a
              href="#catalog"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-medium text-background-50"
            >
              查看条目清单
            </a>
          </nav>
        </div>
      ) : null}
    </header>
  );
}